Vue.component('cardLibrary', {
  template: templates.cardLibrary,
  data() {
    return {
      model: {
        cards: {
          ultimate: [],
          ultra: [],
          legendary: [],
          normal: [],
          viewers: [],
          special_bone: [],
          ascension: [],
          delta: [],
          favorites: [],
 
        },
        page: {
          current: 1,
          max: 18,
          cards: [],
          count: 0
        },
        viewerCard: false,
        selected: false
      }
    }
  },
  mounted() {
    const c = this;
    c.getAllCards();

    c.$root.$on(`selectCard`, data => {
      c.selectCardToggle(data.number, data.toggle);
    });

    c.$root.$on(`updateCards`, data => {
      c.getAllCards()
    });

    c.$root.$on(`updateViewersCard`, data => {
      c.getViewersCards('emmitted');
    });

    c.$root.$on('boneCardAdded', data => {
      c.getAllCards()
    })

    c.$root.$on('confirmDump', data => {
      c.upgradeTier(data)
    })

    c.$root.$on('confirmSpiritForge', data => {
      c.removeCardFromSpiritForge(data)
    })
    
    $('[data-view="viewer-dashboard"]').on('click', '[data-component="playing-card"]', function(e) {
      const cardsLoaded = document.getElementById('cards_loaded');
      const $this = $(this);

      if ($this.hasClass('hq-select')) {
        const number = $this.attr('data-number')
        c.$root.$emit('removedCard', {number: number});
        console.log('hey')
        return;
      }

      if ($this.hasClass('dump-remove')) {
        const number = $this.attr('data-number')
        c.$root.$emit('removeDumpCard', {number: number});
        return;
      }

      if ($this.hasClass('chamber-select')) {
        const number = $this.attr('data-number')
        c.$root.$emit('removeChamberCard', {number: number});
        return;
      }

      if (!e.ctrlKey && utils.onHold == false) {
        c.showCard($this.find('.playing-card-front').clone());
      }
      
    });

    $('[data-view="viewer-dashboard"]').on('click', '[data-component="special-card"]', function(e) {
      const cardsLoaded = document.getElementById('cards_loaded');
      const $this = $(this);

      // if ($this.hasClass('chamber-select')) {
      //   const number = $this.attr('data-number')
      //   c.$root.$emit('removeAscensionCard', {number: number});
      //   return;
      // }

      if ($this.hasClass('hq-select')) {
        const number = $this.attr('data-number')
        c.$root.$emit('removedCard', {number: number});
        return;
      }

      if ($this.hasClass('dump-remove')) {
        const number = $this.attr('data-number')
        c.$root.$emit('removeDumpCard', {number: number});
        return;
      }

      if (!e.ctrlKey && utils.onHold == false) {
        c.showSpecialCard($this.find('.playing-card-front').clone());
      }
      
    });

    $('[data-view="viewer-dashboard"]').on('click', '.view-card', function() {
      c.hideCard();
    });

  },
  methods: {
    selectCardToggle(number, toggle) {
      const c = this;
      for (let card of c.model.cards.viewers) {
        if (card.cardNumber == number && !card.cooldown) {
          card.selected = toggle;
          return;
        }
      }
    },
    showSpecialCard($card) {
      let description = $card.find('.bottom > div:first-of-type').data('description');
      $('.view-card > div').append($card);
      $('.view-card').addClass('is-above').addClass('is-visible');
      $('.view-card .info').removeClass('is-visible');
      $('.view-card .bottom').removeClass('is-hidden');
    },
    showCard($card) {
      let ability = $card.find('.bottom > div:first-of-type').attr('title').replace('Ability: ', '');
      let description = $card.find('.bottom > div:first-of-type').data('description');
      $('.view-card > div').append($card).append(`<p class="description"><span>${ability}:</span> ${description}</p>`);
      $('.view-card').addClass('is-above').addClass('is-visible');
      $('.view-card .info').removeClass('is-visible');
      $('.view-card .bottom').removeClass('is-hidden');
    },
    hideCard() {
      $('.view-card').removeClass('is-visible');
      setTimeout(function() {
        $('.view-card').removeClass('is-above');
        $('.view-card > div').html('');
      }, 300);
    },
    getPage() {
      const c = this;
      const totalCards = c.model.cards.viewers.length;
      const start = ((c.model.page.current * c.model.page.max) - c.model.page.max);
      const end = start + c.model.page.max;

      c.model.page.count = Math.ceil(totalCards / c.model.page.max);
      c.model.page.cards = c.model.cards.viewers.slice(start, end);

      setTimeout(function() {
        $('.playing-card:not(.disabled)').addClass('flipped');
      }, 1000);

    },
    setPage(number) {
      const c = this;
      c.model.page.current = number;
      c.getPage();
    },
    previousPage() {
      const c = this;
      c.model.page.current--;
      c.getPage();
    },
    nextPage() {
      const c = this;
      c.model.page.current++;
      c.getPage();
    },
    getAllCards() {
      const c = this;

      cardService.getActive()
        .then(function (response) {

          for (let data of response.data) {
            data.image = `${root}/images/cards/${data.id}.png`;
          }

          let cards = playingCards.groupCardsByTier(response.data);
          c.model.cards.ultimate = cards.ultimate.map(v => ({...v, count: 0}));
          c.model.cards.ultra = cards.ultra.map(v => ({...v, count: 0}));
          c.model.cards.legendary = cards.legendary.map(v => ({...v, count: 0}));
          c.model.cards.normal = cards.normal.map(v => ({...v, count: 0}));

          c.getViewersCards('getCard');

          c.ViewerFavorites();
          c.viewBoneCards();
          c.viewAscension();
          c.viewInventory();

          console.log(c.model)
        })
        .catch(function (error) {
          
        });
    },
    getViewersCards(condition) {
      const c = this;

      userService.unlockedCards()
        .then(function (response) {

          c.model.cards.viewers = c.getViewersCardsInfo(response.data).map(v => ({...v, selected: false}));
    
          c.setCardCount();

          if(condition === 'emmitted'){
              $('.playing-card:not(.disabled)').addClass('fade_in');
          }
          else{
            c.getPage();
            setTimeout(function() {
       
              $(".pagination").rPage();
              $('.playing-card:not(.disabled)').addClass('flipped');
            }, 1000);
          }
       

          // setTimeout(function() {
          //   c.getViewersCards('refreshed');
          // }, 60000);

        })
        .catch(function (error) {
          
        });
    },
    getViewersCardsInfo(cards) {
      const c = this;
      let viewersCards = [];

      for (let card of cards) {
        let viewersCard = c.findCard(card.id);

        if (viewersCard != null) {
          card.image = `${root}/images/cards/${card.id}.png`;
          viewersCards.push(playingCards.getCardStats(card));
        }
      }

      return viewersCards;
    },
    setCardCount() {
      const c = this;
      c.checkCards(c.model.cards.ultimate);
      c.checkCards(c.model.cards.ultra);
      c.checkCards(c.model.cards.legendary);
      c.checkCards(c.model.cards.normal);
    },
    checkCards(cards) {
      const c = this;
      for (let card of cards) {
        card = c.getGetStats(card);
        card.count = c.getUnlockQuantity(card);
      }
    },
    getUnlockQuantity(card) {
      const c = this;
      let count = 0;
      for (let viewerCard of c.model.cards.viewers) {
        if (card.id == viewerCard.id && card.tier == viewerCard.tier && viewerCard.active) {
          count++;
        }
      }
      return count;
    },
    findCard(id) {
      const c = this;
      for (let card of c.model.cards.normal) {
        if (card.id == id) {
          return {...card};
        }
      }
      for (let card of c.model.cards.ultimate) {
        if (card.id == id) {
          return {...card};
        }
      }
      return null;
    },
    getGetStats(card) {
      const c = this;
      for (let viewerCard of c.model.cards.viewers) {
        if (card.id == viewerCard.id && card.tier == viewerCard.tier) {
          card.name = viewerCard.name;
          card.description = viewerCard.description;
          card.accuracy = viewerCard.accuracy;
          card.attack = viewerCard.attack;
          card.defence = viewerCard.defence;
          card.hp = viewerCard.hp;
          card.speed = viewerCard.speed;
          card.ability = viewerCard.ability;
          card.type = viewerCard.type;

          if (viewerCard.cooldown) {
            card.cooldown = viewerCard.cooldown;
          }

          return card;
        }
      }
      return card;
    }
    ,
    ViewerFavorites(){
      const c = this;

      userService.getFavorites()
      .then(function (response) {

        c.model.cards.favorites = c.getViewersCardsInfo(response.data).map(v => ({...v, selected: false}));

        c.getPage();
        c.setCardCount();

        setTimeout(function() {
          $(".pagination").rPage();
          $('.playing-card:not(.disabled)').addClass('flipped');
      
        }, 1000);

      })
      .catch(function (error) {
        
      });
    },
    viewBoneCards(){
      const c = this;

      userService.getBoneCards()
      .then(function (response) {

        c.model.cards.special_bone = response.data;

        c.getPage();
        c.setCardCount();

        setTimeout(function() {
          $(".pagination").rPage();
          $('.playing-card:not(.disabled)').addClass('flipped');
      
        }, 1000);

      })
      .catch(function (error) {
        
      });
    },
    viewAscension(){
      const c = this;

      userService.getAscension()
      .then(function (response) {

        c.model.cards.ascension = response.data;

        c.getPage();
        c.setCardCount();

        setTimeout(function() {
          $(".pagination").rPage();
          $('.playing-card:not(.disabled)').addClass('flipped');
      
        }, 1000);

      })
      .catch(function (error) {
        
      });
    },
    upgradeTier(data){
      const c = this;

      data.twitchId = utils.cookies.get('user_id');

      userService.upgradeTier(data)
      .then(function (response){
        c.getAllCards()
        setTimeout(function(){
          c.$root.$emit('tierUpdated');
        }, 3000)
      })
      .catch(function (error){

      })
    },
    removeCardFromSpiritForge(data){
      const c = this;

      data.type = "Inventory"
      data.active = false
      userService.spiritForge(data)
      .then(function (response){
        c.getAllCards()
        setTimeout(function(){
          c.$root.$emit('updateBark');
        }, 1000)
      })
      .catch(function (error){

      })
    }
    
  }
});